import Icon from '../assets/PumpFunIcon.png';

export function PumpFunIcon({ className = '' }: { className?: string }) {
    return <img className={'size-[28px] ' + className} src={Icon} alt='Pump Icon' />;
}
